import { asyncRouterMap, constantRouterMap } from 'src/router';

/**
 * 通过meta.role判断是否与当前用户权限匹配
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.role) {
    return roles.some(role => route.meta.role.indexOf(role) >= 0)
  } else {
    return true
  }
}

/**
 * 递归过滤异步路由表，返回符合用户角色权限的路由表
 * @param asyncRouterMap
 * @param roles
 */
function filterAsyncRouter(asyncRouterMap, roles) {
  const accessedRouters = asyncRouterMap.filter(route => {
    if (hasPermission(roles, route)) {

      if (route.children && route.children.length) {
        route.children = filterAsyncRouter(route.children, roles)
      }
      return true
    }
    return false
  })
  return accessedRouters
}

/**
 * 递归查找当前路由
 * @param asyncRouterMap
 * @param to
 */
function getNowRouter(asyncRouterMap, to) {
  return asyncRouterMap.some(route => {
    if (to.path.indexOf(route.path) !== -1) {
      return true;
    }
    else if (route.children && route.children.length) { //如果有孩子就遍历孩子
      return getNowRouter(route.children, to)
    }
  })

}

const permission = {
  state: {
    routers: constantRouterMap,
    addRouters: [],
    siderbar_routers: [],
    isRoutesInitialized: false, // 添加路由初始化状态
  },
  mutations: {
    SET_ROUTERS: (state, routers) => {
      state.addRouters = routers;
      state.routers = constantRouterMap.concat(routers);
      state.isRoutesInitialized = true // 设置路由已初始化
    },
    RESET_ROUTES: (state) => {
      state.addRouters = []
      state.routers = constantRouterMap
      state.isRoutesInitialized = false // 重置路由初始化状态
    },
    SET_NOW_ROUTERS: (state, to) => {
      // 递归访问 accessedRouters，找到包含to 的那个路由对象，设置给siderbar_routers
      console.log(state.addRouters)
      state.addRouters.forEach(e => {
        if (e.children && e.children.length) {
          if (getNowRouter(e.children, to) === true)
            state.siderbar_routers = e;
        }

      })
    }
  },
  actions: {
    GenerateRoutes({ commit, state }, { roles }) {
      return new Promise(resolve => {
        // 如果路由已经初始化，直接返回
        if (state.isRoutesInitialized) {
          resolve()
          return
        }
        
        let accessedRouters
        if (roles.includes('admin')) {
          // admin 可以看到所有页面
          accessedRouters = asyncRouterMap.filter(route => route.path === '/admin')
        } else if (roles.includes('jixiu')) {
          // jixiu 只能看到技修相关的路由
          accessedRouters = asyncRouterMap.filter(route => route.path === '/jixiu')
        } else {
          accessedRouters = filterAsyncRouter(asyncRouterMap, roles)
        }
        
        commit('SET_ROUTERS', accessedRouters)
        resolve()
      })
    },
    ResetRoutes({ commit }) {
      commit('RESET_ROUTES')
    },
    getNowRoutes({ commit }, data) {
      return new Promise(resolve => {
        //data => to
        commit('SET_NOW_ROUTERS', data);
        resolve();
      })
    },
  },
};

export default permission;
